/* globals ENVIRONMENT */
import Utilities from './Utilities';
/**
 *
 * @param {Debugger} instance - Debugger instance
 */
const init = (instance) => {
  const sensorScriptType = instance.basicSettings.scriptType === 'modern' ? '[MODERN]' : '[LEGACY]';
  if (Utilities.lsoSupport() === true) {
    const lsoDebugState = window.localStorage.getItem(instance.basicSettings.storage.debug.key);
    if (console && typeof console.log === 'function' && lsoDebugState) {
      if (lsoDebugState === instance.basicSettings.storage.debug.value) {
        instance.debug('local storage debug state: activated');
        // Activate debugging
        // eslint-disable-next-line no-param-reassign
        instance.useDebugger = true;
      } else {
        console.log(`[IMA] ${sensorScriptType} [DEBUG] local storage debug unknown state: '${lsoDebugState}'.`);
        // Deactivate debugging
        // eslint-disable-next-line no-param-reassign
        instance.useDebugger = false;
      }
    }
  } else {
    console.log(`[IMA] ${sensorScriptType} [DEBUG] local storage is not supported. Debugging deactivated.`);
    // Deactivate debugging
    // eslint-disable-next-line no-param-reassign
    instance.useDebugger = false;
  }
};
/**
 * @class Debugger
 */
export default class Debugger {
  /**
   * Initiates a new instance
   *
   * @param {Object} basicSettings - Basis sensor settings
   */
  constructor(basicSettings) {
    this.name = 'DebuggerClass';
    this.basicSettings = basicSettings;
    // Activate debugging only in testing and development environments
    this.useDebugger = ['testing', 'development'].includes(ENVIRONMENT);
    init(this);
  }

  /**
   * Logs a debug message to the local console
   *
   * @param {...*} args - Debug arguments
   */
  debug(...args) {
    if (this.useDebugger) {
      const sensorScriptType = this.basicSettings.scriptType === 'modern' ? '[MODERN]' : '[LEGACY]';
      args.unshift(`[IMA] ${sensorScriptType} [DEBUG]`);
      console.log(...args);
    }
  }
}
